<div class="add__professional--workspace min-h-[600px] h-[600px] custom-dialog-scrollbar">
  <div class="add__professional--workspace--close">
    <button mat-icon-button class="lex justify-end" (click)="closeDialog()">
      <span class="material-icons relative text-[#B1ACB0] font-semibold text-[30px] leading-9">close </span>
    </button>
  </div>

  <div>
    @if (data.isEntity) {
    <div class="workspace__stepper--container">
      <div class="workspace__stepper--container--item" [ngStyle]="{ background: entityNameSection ? '#25508E' : '#7E9BD4' }"></div>
      <div class="workspace__stepper--container--item-2" [ngStyle]="{ background: membersSection ? '#25508E' : '#F3F6FA' }"></div>
    </div>
    }

    @if (entityNameSection || !data.isEntity) {
    <div class="app__centered-item flex-col h-[84%]">
      <div class="workspace__stepper--manage--setup">
        <div class="add__workspace--name">
          <form [formGroup]="addTemplateForm">
            <div class="flex flex-col">
              <div class="app__form--attribute--title w-full text-center text-2xl leading-9">Add Template</div>
              <div class="w-full flex flex-col gap-2 mt-5">
                <mat-form-field class="login-signup-form-desing w-full" floatLabel="never">
                  <mat-label class="automtic-form-desing-lable pl-1"> Template Name </mat-label>
                  <input
                    class="pl-1"
                    matInput
                    placeholder="Name"
                    formControlName="templateName"
                    (focus)="selectAllContent($event)"
                    (keydown)="disableWhiteSpaceOnFirstCharacter($event)"
                  />
                </mat-form-field>

                <mat-form-field class="login-signup-form-desing w-full" floatLabel="never">
                  <mat-label class="automtic-form-desing-lable pl-1"> Template Type </mat-label>
                  <mat-select class="transaction__select--form--field" placeholder="Type" formControlName="templateType" [disabled]="data.isEntity">
                    <mat-select-trigger>
                      @if (addTemplateForm.get('templateType')?.value) {
                        {{ getSelectedTemplateTypeName() }}
                      } @else {
                        <span>{{ data.isEntity ? 'Entity' : '' }}</span>
                      }
                    </mat-select-trigger>
                    @for (item of filteredTemplateTypes; track item) {
                    <mat-option
                      [value]="item.id"
                      [ngClass]="{ 'placeholder-option': data.isEntity && item.id === placeholderEntityId }"
                      [ngStyle]="{ 'background-color': data.isEntity && item.id === placeholderEntityId ? '#F3F6FA' : 'white', 'color': data.isEntity && item.id === placeholderEntityId ? '#25508E' : 'black' }"
                    >
                      @if (data.isEntity) {
                      <!-- Simple display for entities (no image, no type_template) -->
                      <span class="flex items-center justify-between w-full">
                        <span [ngStyle]="{ 'color': item.id === placeholderEntityId ? '#25508E' : 'black', 'font-weight': item.id === placeholderEntityId ? 'bold' : 'normal' }">{{ item.type }}</span>
                        @if (item.id === placeholderEntityId && addTemplateForm.get('templateType').value !== item.id) {
                        <span class="flex items-center gap-1">
                          <mat-icon
                            class="placeholder-info-icon ml-1"
                            [matTooltip]="placeholderTooltip"
                            matTooltipClass="placeholder-tooltip"
                            matTooltipPosition="above"
                            style="color: #25508e !important;"
                          >
                            info_outline
                          </mat-icon>
                        </span>
                        }
                      </span>
                      } @else {
                      <!-- Rich display for non-entities (match document-linking-template style) -->
                      <div class="flex justify-between py-2 cursor-pointer w-full">
                        <div class="flex gap-2">
                          @if (item.image) {
                          <img
                            [src]="item.image"
                            style="height: 16px"
                            class="bg-[#EBEDFA] p-2 w-9 h-9 rounded"
                          />
                          } @else {
                          <span class="material-icons bg-[#EBEDFA] p-2 w-9 h-9 rounded text-[#b0b0b0] text-base flex items-center justify-center">
                            insert_drive_file
                          </span>
                          }
                          <div>
                            <p class="text-[#18191c] font-semibold text-xs m-0" [matTooltip]="item.type">
                              {{ item.type | truncateStrPipe : 48 }}
                            </p>
                            @if (item.type_template) {
                            <p class="text-[#707070] text-xs font-normal m-0" [matTooltip]="item.type_template">
                              {{ item.type_template | truncateStrPipe : 30 }}
                            </p>
                            }
                          </div>
                        </div>
                      </div>
                      }
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                @if (data.isEntity && isPlaceholderSelected) {
                <mat-form-field class="login-signup-form-desing w-full" floatLabel="never">
                  <mat-label class="automtic-form-desing-lable pl-1"> Select Vault </mat-label>
                  <mat-select class="transaction__select--form--field" placeholder="Select Vault" formControlName="placeholderVault">
                    <mat-select-trigger>
                      @if (addTemplateForm.get('placeholderVault')?.value) {
                        {{ getSelectedPlaceholderVaultName() }}
                      } @else {
                        <span></span>
                      }
                    </mat-select-trigger>
                    @if (placeholderVaultOptions?.length) {
                    @for (vault of placeholderVaultOptions; track vault?.id) {
                    <mat-option [value]="vault?.id">
                      <div class="flex items-center gap-2 py-2">
                        <div class="flex justify-center items-center h-[40px] w-[40px] bg-[#EBF0FA] rounded-[4px]">
                          @if (!vault?.type) {
                            <img class="h-[32px] w-[32px]" src="assets/images/vault/personal.svg" />
                          } @if (vault?.type === 'personal') {
                            <img class="h-[32px] w-[32px]" src="assets/images/vault/personal.svg" />
                          } @if (vault?.type === 'shared') {
                            <img class="h-[32px] w-[32px]" src="assets/images/vault/shared.svg" />
                          } @if (vault?.type === 'holding' || vault?.type === 'trust' || vault?.type === 'entity') {
                            <img class="h-[32px] w-[32px]" src="assets/images/vault/entity.svg" />
                          }
                        </div>
                        <div class="ml-2 gap-[2px]" style="display: flex; flex-direction: column">
                          <div class="text-[12px] font-[500] font-open-sans text-[#18191c] leading-normal">{{ vault?.name | truncateStrPipe : 35 }}</div>
                          <div class="capitalize text-[#707070] text-[10px] font-medium font-open-sans leading-normal">{{ vault?.type }}</div>
                        </div>
                      </div>
                    </mat-option>
                    }
                    } @else {
                    <mat-option [value]="''" disabled>No vaults available</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                }

                @if (data.isEntity && currentUser?.user_type == 'Professional' && !isPlaceholderSelected) {
                <mat-form-field class="login-signup-form-desing w-full" appearance="fill">
                  <mat-label class="automtic-form-desing-lable"> Vault Owner </mat-label>
                  <mat-select
                    class="transaction__select--form--field"
                    panelClass="app__inline--mat--select--dropdown"
                    formControlName="vaultOwner"
                    [disableOptionCentering]="true"
                    (selectionChange)="onSelectChange($event)"
                  >
                    <div
                      class="app__discovery--header--search--field w-[94%] h-[38px] border-[1.2px] border-[#B1ACB066] font-open-sans not-italic m-3 mt-5"
                    >
                      <div class="app__centered-item w-full h-full px-5">
                        <span class="mt-[-2px] text-[#5475C0]"><img src="assets/images/blue-search-icon.svg" width="14px" height="14px" /></span>
                        <input
                          class="h-full w-full ml-2 border-none outline-none text-[12px]"
                          type="text"
                          [formControl]="searchStringState"
                          placeholder="Search"
                          autocomplete="off"
                          (keydown.space)="$event.stopPropagation()"
                        />
                        @if(searchStringState?.value){
                        <span matSuffix (click)="onClearSearchInput()">
                          <mat-icon class="text-[#898F9E] text-xl hover:cursor-pointer">close</mat-icon>
                        </span>
                        }
                      </div>
                    </div>
                    <div
                      class="max-h-[170px] min-h-[60px] overflow-y-auto mb-2"
                      *ngIf="(allWorkspaceMembers | filterWorkspace : searchStringState?.value).length; else showEmptyState"
                    >
                      <mat-option
                        class="mr-1"
                        *ngFor="let member of allWorkspaceMembers | filterWorkspace : searchStringState?.value; let i = index"
                        [value]="member.user_id"
                      >
                        <span> {{ member.name }} </span>
                      </mat-option>
                    </div>
                    <ng-template #showEmptyState>
                      <div class="h-[50px]" *ngIf="(allWorkspaceMembers | filterWorkspace : searchStringState?.value).length == 0">
                        <span class="px-4 mt-4 text-gray-400"> Owner not found </span>
                      </div>
                    </ng-template>
                  </mat-select>
                </mat-form-field>
                }

                @if (!data.isEntity) {
                <mat-form-field class="login-signup-form-desing w-full" floatLabel="never">
                  <mat-label class="automtic-form-desing-lable pl-1"> Select Vault </mat-label>
                  <mat-select class="transaction__select--form--field" placeholder="Select Vault" formControlName="selectedVault">
                    <mat-select-trigger>
                      @if (addTemplateForm.get('selectedVault')?.value) {
                        {{ getSelectedVaultName() }}
                      } @else {
                        <span></span>
                      }
                    </mat-select-trigger>
                    @for (vault of filteredVaults; track vault?.id) {
                    <mat-option [value]="vault?.id">
                      <div class="flex items-center gap-2 py-2">
                        <div class="flex justify-center items-center h-[40px] w-[40px] bg-[#EBF0FA] rounded-[4px]">
                          @if (!vault?.type) {
                            <img class="h-[32px] w-[32px]" src="assets/images/vault/personal.svg" />
                          } @if (vault?.type === 'personal') {
                            <img class="h-[32px] w-[32px]" src="assets/images/vault/personal.svg" />
                          } @if (vault?.type === 'shared') {
                            <img class="h-[32px] w-[32px]" src="assets/images/vault/shared.svg" />
                          } @if (vault?.type === 'holding' || vault?.type === 'trust' || vault?.type === 'entity') {
                            <img class="h-[32px] w-[32px]" src="assets/images/vault/entity.svg" />
                          }
                        </div>
                        <div class="ml-2 gap-[2px]" style="display: flex; flex-direction: column">
                          <div class="text-[12px] font-[500] font-open-sans text-[#18191c] leading-normal">{{ vault?.name | truncateStrPipe : 35 }}</div>
                          <div class="capitalize text-[#707070] text-[10px] font-medium font-open-sans leading-normal">{{ vault?.type }}</div>
                        </div>
                      </div>
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                }
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    }

    @if (data.isEntity && membersSection) {
    <div class="app__centered-item flex-col h-[80%]">
      <div class="workspace__stepper--manage--setup">
        <ng-container>
          <div class="add__workspace--member--container py-8">
            <div class="w-full flex flex-col">
              <div class="app__form--attribute--title w-full text-center">
                <div class="text-2xl leading-9 max-[480px]:text-sm max-[480px]:mb-0">Manage Members</div>
              </div>
              <div class="w-full mt-2 mb-0">
                <div class="app__centered-item w-full">
                  <div class="w-full">
                    <manage-users
                      [data]="allNonProfessionalExistingUsers"
                      [userType]="'family'"
                      [isInputFullWidth]="true"
                      [placeHolder]="'Search Connections'"
                      [selectedUsers]="selectedMembers"
                      (openInviteDialog)="openInviteDialog()"
                      (selectConnectedUser)="selectConnectedUser($event)"
                    ></manage-users>
                  </div>
                </div>
              </div>
              <div class="w-full overflow-hidden" *ngIf="selectedMembers?.length">
                <div class="w-full text-sm font-sans font-bold">
                  Members <span class="text-k-blue">({{ selectedMembers.length }})</span>
                </div>
                <div class="w-full flex flex-col justify-between mt-3 max-[480px]:py-0 max-[480px]:px-[15px]">
                  <div class="w-full max-h-[250px] overflow-y-auto" [class]="selectedMembers.length > 3 ? 'pr-[6px]' : ''">
                    @for (user of selectedMembers; track user; let index = $index) {
                    <div
                      class="app__between--justified--content workspace__mobile---member--view workspace__member--infos--add"
                      [class]="index != 0 ? 'mt-4' : ''"
                    >
                      <div class="flex items-center max-[480px]:flex-col">
                        @if (user?.memberUser?.first_name || user?.memberUser?.user_first_name || user?.memberUser?.user_nick_name ||
                        user?.memberUser?.name) {
                        <div class="flex items-center max-[480px]:items-start">
                          @if (user?.memberUser?.isGroup) {
                          <div>
                            <img class="w-[46px] h-[46px]" src="assets/images/round-group-name.svg " />
                          </div>
                          } @if (!user?.memberUser?.isGroup) {
                          <ngx-avatars
                            [size]="50"
                            src="{{ user?.memberUser?.user_profile_image_url }}"
                            name="{{
                              user?.memberUser?.name ??
                                user?.memberUser?.user_nick_name ??
                                user?.memberUser?.nick_name ??
                                user?.memberUser?.user_first_name + ' ' + user?.memberUser?.user_last_name ??
                                user?.memberUser?.first_name + ' ' + user?.memberUser?.last_name
                            }}"
                            [round]="true"
                            initialsSize="2"
                          ></ngx-avatars>
                          }
                          <div class="flex flex-col gap-[2px]">
                            <span class="workspace__member--infos--name">{{
                              user.memberUser?.name ??
                                user.memberUser?.user_nick_name ??
                                user.memberUser?.nick_name ??
                                user.memberUser?.user_first_name + ' ' + user.memberUser?.user_last_name ??
                                user.memberUser?.first_name + ' ' + user.memberUser?.last_name
                                | titlecase
                                | truncateStrPipe : 24
                            }}</span>
                          </div>
                        </div>
                        }
                      </div>

                      @if(user?.is_creator){
                      <div class="mr-4"><span class="workspace__member--tag">Creator</span></div>
                      }@else{
                      <div class="app__centered-item text-center mr-2">
                        <span class="hover:cursor-pointer" (click)="deleteMember(user)">
                          <img src="assets/images/delete-alert.svg" class="w-8 h-8" />
                        </span>
                      </div>
                      }
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    }
  </div>

  <div class="add__workspace--bottom--section" [ngClass]="{ 'justify-end': true }">
    @if (data.isEntity && membersSection) {
    <div class="flex gap-2 justify-between w-full">
      <div (click)="backItem()">
        <button class="worspace__setup--btn bg-[#ffffff] text-[#25508e] border border-[#25508e]" type="button">
          Back
        </button>
      </div>
      <div (click)="isFormValid() && save()">
        <button
          class="worspace__setup--btn bg-[#25508e] text-[#ffffff]"
          type="button"
          [class.disable-button-continue]="!isFormValid()"
        >
          Save
        </button>
      </div>
    </div>
    } @else {
    <div (click)="isFormValid() && save()">
      <button
        class="worspace__setup--btn bg-[#25508e] text-[#ffffff]"
        type="button"
        [class.disable-button-continue]="!isFormValid()"
      >
        @if (data.isEntity && isPlaceholderSelected) {
          <span>Save</span>
        } @else if (data.isEntity) {
          <span>Next</span>
        } @else {
          <span>Save</span>
        }
      </button>
    </div>
    }
  </div>
</div>

